(ns ballot-scout-v2-frontend.subs
  (:require
   [ballot-scout-v2-frontend.auth :as auth]
   [ballot-scout-v2-frontend.db :as db]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.util :as util]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::name
 (fn [db]
   (:name db)))

(rf/reg-sub
 ::user
 (fn [db]
   (:user db)))

(rf/reg-sub
 ::admin?
 :<- [::user]
 (fn [user]
   (auth/admin? (:profile user))))

(rf/reg-sub
 ::partner-admin?
 :<- [::current-partner]
 :<- [::user]
 (fn [[#:partner{:keys [id]} user]]
   (or (auth/admin? (:profile user))
       (and (auth/partner-admin? (:profile user))
            (= id (get-in user [:profile :partner-id]))))))

(rf/reg-sub
 ::on-partner-admin-page?
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (boolean  (get-in current-route [:data :partner-admin-page?]))))

(rf/reg-sub
 ::on-global-stats-page?
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (= (get-in current-route [:data :name]) :ballot-scout-v2-frontend.routes/global-stats)))

(rf/reg-sub
 ::can-view-partner-admin-pages?
 :<- [::admin?]
 :<- [::partner-admin?]
 (fn [[admin? partner-admin?]]
   (or admin? partner-admin?)))

(rf/reg-sub
 ::auth0-retrieve-profile-error
 (fn [db]
   (get-in db [:auth0 :profile-retrieval-error])))

(rf/reg-sub
 ::auth0-status
 (fn [db]
   (get-in db [:auth0 :status])))

;; partner subs

(rf/reg-sub
 ::all-partners
 (fn [db]
   (db/all-partners db {:full false})))

(rf/reg-sub
 ::partner-by-id
 (fn [db [_ partner-id]]
   (db/partner-by-id db partner-id)))

(rf/reg-sub
 ::partner-by-slug
 (fn [db [_ partner-slug]]
   (db/partner-by-slug db partner-slug)))

(rf/reg-sub
 ::current-partner-slug
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (get-in current-route [:path-params :partner-slug])))

(rf/reg-sub
 ::current-partner
 :<- [::current-partner-slug]
 (fn [current-partner-slug]
   @(rf/subscribe [::partner-by-slug current-partner-slug])))

;; jurisdiction subs

(rf/reg-sub
 ::jurisdiction-by-id
 (fn [db [_ jurisdiction-id]]
   (db/jurisdiction-by-id db jurisdiction-id)))

(rf/reg-sub
 ::jurisdiction-by-slug
 (fn [db [_ jurisdiction-slug]]
   (db/jurisdiction-by-slug db jurisdiction-slug)))

(rf/reg-sub
 ::current-jurisdiction-slug
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 :<- [::current-partner]
 (fn [[current-route]]
   (get-in current-route [:path-params :jurisdiction-slug])))

(rf/reg-sub
 ::current-jurisdiction
 :<- [::current-jurisdiction-slug]
 (fn [current-jurisdiction-slug]
   @(rf/subscribe [::jurisdiction-by-slug current-jurisdiction-slug])))

;; election subs

(rf/reg-sub
 ::election-by-slug-and-partner-id
 (fn [db [_ election-slug partner-id]]
   (db/election-by-slug-and-partner-id db election-slug partner-id)))

(rf/reg-sub
 ::current-election-slug
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (get-in current-route [:path-params :election-slug])))

(rf/reg-sub
 ::cached-election-slug
 (fn [db]
   (:cached-election-slug db)))

(rf/reg-sub
 ::election-slug-for-sidebar
 :<- [::current-election-slug]
 :<- [::cached-election-slug]
 :<- [::current-jurisdiction]
 :<- [::current-partner]
 (fn [[current-election-slug cached-election-slug current-jurisdiction current-partner]]
   (or current-election-slug
       cached-election-slug
       (-> current-jurisdiction :jurisdiction/current-election :election/slug)
       (some-> current-partner :partner/jurisdictions first :jurisdiction/current-election :election/slug))))

(rf/reg-sub
 ::current-election
 :<- [::current-partner]
 :<- [::current-election-slug]
 (fn [[#:partner{:keys [id]} current-election-slug]]
   @(rf/subscribe [::election-by-slug-and-partner-id current-election-slug id])))

(rf/reg-sub
 ::elections-for-jurisdiction
 (fn [db [_ jurisdiction-slug]]
   (let [jurisdiction @(rf/subscribe [::jurisdiction-by-slug jurisdiction-slug {:full true}])]
     (when (and (some? jurisdiction) (nil? (db/jurisdiction-elections db jurisdiction-slug)))
       (rf/dispatch [::events/fetch-elections-for-jurisdiction jurisdiction-slug]))
     (db/jurisdiction-elections db jurisdiction-slug))))

(rf/reg-sub
 ::elections-for-partner
 (fn [db [_ partner-slug]]
   (let [partner @(rf/subscribe [::partner-by-slug partner-slug {:full true}])]
     (when (and (some? partner) (nil? (db/partner-elections db partner-slug)))
       (rf/dispatch [::events/fetch-elections-for-partner partner-slug]))
     (db/partner-elections db partner-slug))))

;; import subs

(rf/reg-sub
 ::import-by-id
 (fn [db [_ import-id]]
   (db/import-by-id db (util/->int import-id))))

(rf/reg-sub
 ::current-import-id
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (util/->int (get-in current-route [:path-params :import-id]))))

(rf/reg-sub
 ::current-import
 :<- [::current-import-id]
 (fn [current-import-id]
   @(rf/subscribe [::import-by-id current-import-id])))

;; disposition subs

(rf/reg-sub
 ::disposition-by-id
 (fn [db [_ dispo-id]]
   (db/disposition-by-id db (util/->int dispo-id))))

(rf/reg-sub
 ::current-disposition-id
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (util/->int (get-in current-route [:path-params :disposition-id]))))

(rf/reg-sub
 ::current-disposition
 :<- [::current-disposition-id]
 (fn [current-dispo-id]
   @(rf/subscribe [::disposition-by-id current-dispo-id])))

;; route subs

(rf/reg-sub
 ::query-params
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (:query-params current-route)))

(rf/reg-sub
 ::route-name
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (get-in current-route [:data :name])))

(rf/reg-sub
 ::index-page-ready?
 (fn [db]
   (:index-page-ready? db)))

(rf/reg-sub
 ::page-name
 (fn [db]
   (:page-name db)))

;; stats state
(rf/reg-sub
 ::stats-tab
 :<- [:ballot-scout-v2-frontend.routes/current-route]
 (fn [current-route]
   (get-in current-route [:data :global-stats :stats-tab])))

;; Mobile
(rf/reg-sub
 ::view-mobile-menu
 (fn [db]
   (:view-mobile-menu db)))

;; Banner
(rf/reg-sub
 ::show-banner?
 (fn [db]
   (:show-banner? db)))
